// 引入axios
import axios from 'axios'
// 引入elementui的Message
import { Message } from 'element-ui'
import router from '@/router'
import _ from 'lodash'
// 配置服务器地址
// axios.defaults.baseURL = process.env.VUE_APP_API_URL

const service = axios.create({
    baseURL: process.env.VUE_APP_API_URL,

    timeout: 200000 // 请求超时时间
})

// 创建一个节流函数，限制请求频率为每秒一次
// const throttledRequest = _.throttle((config) => {
//     return config
// }, 1000);

// 请求拦截器
service.interceptors.request.use(config => {
    // 设置token
    config.headers['business'] = "talent"
    config.headers['version'] = '1.0.5'
    const token = localStorage.getItem('tk')
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config
}, err => {
    return Promise.reject(err)
})

// 避免同一"登录已过期"提示在并发请求时重复弹出 n 次
let sessionExpiredToastLock = false

// 响应拦截器
service.interceptors.response.use(res => {
    const code = res && res.data && res.data.code
    const msg  = res && res.data && res.data.msg

    if (code === 401) {
        // 登录态失效(token 过期 / token 被服务端清除)。清掉本地态 + 跳回登录页 + 单一提示。
        localStorage.removeItem('tk')
        localStorage.removeItem('userName')
        localStorage.removeItem('userAccount')
        localStorage.removeItem('id')
        if (!sessionExpiredToastLock) {
            sessionExpiredToastLock = true
            Message.error(msg || '登录已过期，请重新登录')
            setTimeout(() => { sessionExpiredToastLock = false }, 1500)
        }
        if (router.currentRoute.path !== '/' && router.currentRoute.path !== '/login') {
            router.push('/')
        }
        return res
    }

    if (code === 202 || code === 422 || code === 403) {
        Message.error(msg)
    }
    if (code === 500) {
        Message.error(msg || '服务器出问题了')
    }
    return res
}, err => {
    if (err && err.code === 'ECONNABORTED') {
        Message.error('请求超时')
    }
    if (err && err.code === 'ERR_NETWORK') {
        Message.error(err.message || '网络连接失败，请检查网络或接口地址')
    }
    return Promise.reject(err)
})

export default service
